let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("h5HSy")).then(() => parcelRequire('l6esU'));